import { render, staticRenderFns } from "./ResellerEditReqList.vue?vue&type=template&id=68bbc906"
import script from "./ResellerEditReqList.vue?vue&type=script&lang=js"
export * from "./ResellerEditReqList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports